

import DialoguePopup from "../../helpers/DialoguePopup";
import React, { useState, useRef, useEffect, Fragment } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import BankService from "../../services/bank.services";
import BoLoader from "../../helpers/BoLoader";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import RefreshToken from "../../helpers/RefreshToken";;

const AddExtrnalTransferBody = props => {
    const { user: currentUser } = useSelector(state => state.auth);

    const [cardHolderDetailsAreaSelected, setCardHolderDetailsAreaSelected] =
        useState("true");
    const [cardDetailsAreaSelected, setCardDetailsAreaSelected] =
        useState("false");
    const [cardHolderDetailsClassName, setTcardHolderDetailsClassName] =
        useState("nav-link active");
    const [cardDetailsClassName, setTcardDetailsClassName] = useState("nav-link");
    const [cardHolderContentClassName, setCardHolderContentClassName] = useState(
        "tab-pane fade show active"
    );
    const [cardContentClassName, setCardContentClassName] =
        useState("tab-pane fade");
    const [modalShow, setModalShow] = React.useState(false);
    const form = useRef();
    const checkBtn = useRef();
    const [modelhdng, setMdlHdng] = useState("");
    const [MdlIcon, setMdlIcon] = useState("");
    const [modelbdy, setMdlBdy] = useState("");
    const [boloader, setBoLoader] = useState(false);
    const [FirstName, setFirstName] = useState("");
    const [errors, setErrors] = useState({}); // Error state

    //Issuer S or ISsuer B For m-Swipe
    const [formData, setFormData] = useState({
        customerId: props?.customerid,
        description: '',
        counterpartyType: '', // e.g., "FIAT_US"
        supportedRails: [], // ["ACH", "FEDWIRE", "SWIFT"]

        profile: {
            profileType: 'INDIVIDUAL', // e.g., "INDIVIDUAL"
            name: '',
            email: '',
            telephoneNumber: '',
            taxReferenceNumber: '',
            dateOfBirth: '',
            address: {
                unitNumber: '',
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                city: '',
                state: '',
                postalCode: '',
                countryCode: ''
            },
            lineOfBusiness: '',
            relationshipToCustomer: ''
        },

        accountInformation: {
            assetTypeId: 'FIAT_MAINNET_USD', // e.g., "FIAT_MAINNET_USD"
            accountNumber: '',
            type: '', // "CHECKING" / "SAVING"
            routingNumber: '',
            swiftBic: '',
            institutionName: '',
            institutionAddress: {
                unitNumber: '',
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                city: '',
                state: '',
                postalCode: '',
                countryCode: ''
            }
        }
    });

    // Custom validation rules
    const validateField = (name, value) => {
        let errorMsg = "";

        // Ensure value is a string before using trim()
        const strValue = value !== undefined && value !== null ? String(value).trim() : "";

        if (!strValue) {
            errorMsg = `${name} is required`;
        } else {
            if (name === "email" && !/^\S+@\S+\.\S+$/.test(strValue)) {
                errorMsg = "Invalid email format";
            }
            if (name === "phone" && !/^\d{10,15}$/.test(strValue)) {
                errorMsg = "Invalid phone number (must be 10-15 digits)";
            }
        }

        return errorMsg;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validate field
        const errorMsg = validateField(name, value);

        setFormData((prev) => {
            const keys = name.split("."); // Handle nested keys like "profile.name"
            let newFormData = { ...prev };
            let nested = newFormData;

            for (let i = 0; i < keys.length - 1; i++) {
                nested = nested[keys[i]]; // Drill down into nested object
            }
            nested[keys[keys.length - 1]] = value; // Set new value

            return newFormData;
        });

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };

    //API Call Start
    const IssueCardHolderHandler = e => {
        if (e) e.preventDefault();
        form.current.validateAll();
        let newErrors = {};
        Object.keys(formData).forEach((field) => {
            const errorMsg = validateField(field, formData[field]);
            if (errorMsg) newErrors[field] = errorMsg;
        });
        // If errors exist, update state and stop submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setBoLoader(true);
        BankService.createcounterparty
            (formData,
            )
            .then(bankData => {
                setBoLoader(false);
                if (bankData && bankData.data && bankData.data.success) {
                    setCardHolderDetailsAreaSelected("false");
                    setCardDetailsAreaSelected("true");
                    setTcardHolderDetailsClassName("nav-link");
                    setTcardDetailsClassName("nav-link active");
                    setCardHolderContentClassName("tab-pane fade");
                    setCardContentClassName("tab-pane fade show active");
                }
            })
            .catch(err => {
                setBoLoader(false);
                let msgBody =
                    err && err.response && err.response.data
                        ? err.response.data.message
                        : "Error Occured While Creating Account";
                let errIcon = "icon-error";
                errorAndSuccessModl("Error", msgBody, errIcon);
                (async () => {
                    setBoLoader(true);
                    let resp = await RefreshToken(
                        err && err.response && err.response.status
                    );
                    if (resp) {
                        IssueCardHolderHandler();
                        setBoLoader(false);
                    } else {
                        setBoLoader(false);
                    }
                })();
            });


    };
    //API Call End
    const errorAndSuccessModl = (heading, body, Icon) => {
        setModalShow(true);
        setMdlHdng(heading);
        setMdlBdy(body);
        setMdlIcon(Icon);
    };

    const IssueCardDoneHandler = e => {
        e.preventDefault();
        // setDisabledBtns(true);
        props.onHide();
    };


    return (
        <Fragment>
            <div className="row">
                <BoLoader loading={boloader} />
                <div className="col-md-12">
                    <h2>External Transfer </h2>
                    <div className="mt-16">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="bo-tabs-mbl">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={cardHolderDetailsClassName} //""
                                                id="cardHolder-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#cardHolder"
                                                type="button"
                                                role="tab"
                                                aria-controls="cardHolder"
                                                aria-selected={cardHolderDetailsAreaSelected}
                                            >
                                                Add External Account
                                            </button>
                                        </li>

                                    </ul>
                                </div>

                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className={cardHolderContentClassName}
                                        id="cardHolder"
                                        role="tabpanel"
                                        aria-labelledby="cardHolder-tab"
                                    >
                                        <div>
                                            <h3>Enter Account details</h3>
                                            <Form onSubmit={(e) => { e.preventDefault() }} ref={form}>
                                                <div className="row mt-16">
                                                    {/* Description */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_description">
                                                            <label>Description*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="description"
                                                                    value={formData.description}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.description && (
                                                                <span className="error_meesage">{errors.description}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Counterparty Type */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_counterpartyType">
                                                            <label>Counterparty Type*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control"
                                                                    name="counterpartyType"
                                                                    value={formData.counterpartyType}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Counterparty Type</option>
                                                                    <option value="FIAT_US">FIAT US</option>
                                                                    <option value="FIAT_EU">FIAT EU</option>
                                                                </select>
                                                            </div>
                                                            {errors.counterpartyType && (
                                                                <span className="error_meesage">{errors.counterpartyType}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Supported Rails - Multi-Select */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_supportedRails">
                                                            <label>Supported Rails*</label>
                                                            <div className="form-controls">
                                                                {/* Display selected options with remove button */}
                                                                <div className="selected-tags">
                                                                    {formData.supportedRails.map((rail) => (
                                                                        <span key={rail} className="selected-tag">
                                                                            {rail}{" "}
                                                                            <button
                                                                                type="button"
                                                                                className="cross-icon"
                                                                                onClick={() => {
                                                                                    setFormData((prev) => ({
                                                                                        ...prev,
                                                                                        supportedRails: prev.supportedRails.filter((r) => r !== rail),
                                                                                    }));
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                </div>

                                                                {/* Multi-select dropdown */}
                                                                <select
                                                                    className="form-control no-icon mt-2"
                                                                    onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        if (selectedValue && !formData.supportedRails.includes(selectedValue)) {
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                supportedRails: [...prev.supportedRails, selectedValue],
                                                                            }));
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="">Select Supported Rail...</option>
                                                                    <option value="ACH">ACH</option>
                                                                    <option value="FEDWIRE">FEDWIRE</option>
                                                                    <option value="SWIFT">SWIFT</option>
                                                                </select>
                                                            </div>

                                                            {errors.supportedRails && (
                                                                <span className="error_meesage">{errors.supportedRails}</span>
                                                            )}
                                                        </div>
                                                    </div>



                                                    {/* Name */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_name">
                                                            <label>Name*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.name"
                                                                    value={formData.profile.name}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.profile?.name && (
                                                                <span className="error_meesage">{errors.profile.name}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_email">
                                                            <label>Email*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="email"
                                                                    className="form-control no-icon"
                                                                    name="profile.email"
                                                                    value={formData.profile.email}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.profile?.email && (
                                                                <span className="error_meesage">{errors.profile.email}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Telephone Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_telephoneNumber">
                                                            <label>Telephone Number*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="tel"
                                                                    className="form-control no-icon"
                                                                    name="profile.telephoneNumber"
                                                                    value={formData.profile.telephoneNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.profile?.telephoneNumber && (
                                                                <span className="error_meesage">{errors.profile.telephoneNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Tax Reference Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_taxReferenceNumber">
                                                            <label>Tax Reference Number*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.taxReferenceNumber"
                                                                    value={formData.profile.taxReferenceNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.profile?.taxReferenceNumber && (
                                                                <span className="error_meesage">{errors.profile.taxReferenceNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Date of Birth */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_dateOfBirth">
                                                            <label>Date of Birth*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="date"
                                                                    className="form-control no-icon"
                                                                    name="profile.dateOfBirth"
                                                                    value={formData.profile.dateOfBirth}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.profile?.dateOfBirth && (
                                                                <span className="error_meesage">{errors.profile.dateOfBirth}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Address - Unit Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_unitNumber">
                                                            <label>Unit Number</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.unitNumber"
                                                                    value={formData.profile.address.unitNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.unitNumber && (
                                                                <span className="error_message">{errors.profile.address.unitNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Address - Line 1 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_addressLine1">
                                                            <label>Address Line 1*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.addressLine1"
                                                                    value={formData.profile.address.addressLine1}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.addressLine1 && (
                                                                <span className="error_message">{errors.profile.address.addressLine1}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Address - Line 2 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_addressLine2">
                                                            <label>Address Line 2</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.addressLine2"
                                                                    value={formData.profile.address.addressLine2}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.addressLine2 && (
                                                                <span className="error_message">{errors.profile.address.addressLine2}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Address - Line 3 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_addressLine3">
                                                            <label>Address Line 3</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.addressLine3"
                                                                    value={formData.profile.address.addressLine3}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.addressLine3 && (
                                                                <span className="error_message">{errors.profile.address.addressLine3}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_city">
                                                            <label>City*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.city"
                                                                    value={formData.profile.address.city}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.city && (
                                                                <span className="error_message">{errors.profile.address.city}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* State */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_state">
                                                            <label>State*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.state"
                                                                    value={formData.profile.address.state}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.state && (
                                                                <span className="error_message">{errors.profile.address.state}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Postal Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_postalCode">
                                                            <label>Postal Code*</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="profile.address.postalCode"
                                                                    value={formData.profile.address.postalCode}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors.profile?.address?.postalCode && (
                                                                <span className="error_message">{errors.profile.address.postalCode}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Country Code - Dropdown */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_countryCode">
                                                            <label>Country Code*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="profile.address.countryCode"
                                                                    value={formData.profile.address.countryCode}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Country</option>
                                                                    <option value="US">United States (US)</option>
                                                                    <option value="CA">Canada (CA)</option>
                                                                    <option value="GB">United Kingdom (GB)</option>
                                                                    <option value="AU">Australia (AU)</option>
                                                                    <option value="DE">Germany (DE)</option>
                                                                    <option value="FR">France (FR)</option>
                                                                    <option value="IN">India (IN)</option>
                                                                    <option value="JP">Japan (JP)</option>
                                                                    <option value="CN">China (CN)</option>
                                                                </select>
                                                            </div>
                                                            {errors.profile?.address?.countryCode && (
                                                                <span className="error_message">{errors.profile.address.countryCode}</span>
                                                            )}
                                                        </div>
                                                    </div>


                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_line_of_business">
                                                            <label>Line of Business*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="profile.lineOfBusiness"
                                                                    value={formData.profile.lineOfBusiness}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Line of Business</option>
                                                                    <option value="ARTS_AND_ANTIQUES">Arts and Antiques</option>
                                                                    <option value="AGRICULTURE">Agriculture</option>
                                                                    <option value="AUDIT_VIDEO">Audit Video</option>
                                                                    <option value="AUTOMOTIVE">Automotive</option>
                                                                    <option value="BANK_CREDIT_UNION">Bank / Credit Union</option>
                                                                    <option value="BIOTECH_PHARMACEUTICAL">Biotech / Pharmaceutical</option>
                                                                    <option value="BOOKSELLER">Bookseller</option>
                                                                    <option value="CONSTRUCTION">Construction</option>
                                                                    <option value="CASINOS_GAMBLING">Casinos / Gambling</option>
                                                                    <option value="CLOTHING">Clothing</option>
                                                                    <option value="CONSULTING_PROFESSIONAL_SERVICES">Consulting / Professional Services</option>
                                                                    <option value="CRYPTOCURRENCY">Cryptocurrency</option>
                                                                    <option value="ECIGARETTES_TOBACCO">E-cigarettes / Tobacco</option>
                                                                    <option value="ENERGY_CHEMICAL_FUEL">Energy / Chemical / Fuel</option>
                                                                    <option value="ENGINEERING">Engineering</option>
                                                                    <option value="ADULT_ENTERTAINMENT">Adult Entertainment</option>
                                                                    <option value="FINANCIAL_AND_CORPORATE_SERVICES">Financial and Corporate Services</option>
                                                                    <option value="FOOD_AND_BEVERAGE">Food and Beverage</option>
                                                                    <option value="FREIGHT_MARINE_SHIPPING_SERVICES">Freight / Marine / Shipping Services</option>
                                                                    <option value="GIFTWARE_SEASONAL">Giftware / Seasonal</option>
                                                                    <option value="GOVERNMENT_PUBLIC_SERVICES">Government / Public Services</option>
                                                                    <option value="HIGH_TECH_SOFTWARE_TELECOMS">High Tech / Software / Telecoms</option>
                                                                    <option value="HOSPITALITY">Hospitality</option>
                                                                    <option value="HOUSEHOLD_GOOD_FURNITURE">Household Goods / Furniture</option>
                                                                    <option value="HUMAN_RESOURCE_SERVICES">Human Resource Services</option>
                                                                    <option value="INDUSTRIAL_EQUIPMENT">Industrial Equipment</option>
                                                                    <option value="INFORMATION_TECHNOLOGY">Information Technology</option>
                                                                    <option value="INSURANCE">Insurance</option>
                                                                    <option value="JEWELLERY_OPTICAL">Jewellery / Optical</option>
                                                                    <option value="LAW">Law</option>
                                                                    <option value="MANUFACTURING">Manufacturing</option>
                                                                    <option value="MARKETING">Marketing</option>
                                                                    <option value="MEDIA_PUBLISHING">Media / Publishing</option>
                                                                    <option value="MEDICAL_HEALTHCARE">Medical / Healthcare</option>
                                                                    <option value="MEDICAL_TOURISM">Medical Tourism</option>
                                                                    <option value="MINING">Mining</option>
                                                                    <option value="MONEY_SERVICE_BUSINESS">Money Service Business</option>
                                                                    <option value="NON_PROFIT_CHARITY">Non-Profit / Charity</option>
                                                                    <option value="ONLINE_RETAIL">Online Retail</option>
                                                                    <option value="PAYROLL">Payroll</option>
                                                                    <option value="PENSION">Pension</option>
                                                                    <option value="PERSONAL_CARE_PRODUCTS">Personal Care Products</option>
                                                                    <option value="PHOTOGRAPHY">Photography</option>
                                                                    <option value="REAL_ESTATE">Real Estate</option>
                                                                    <option value="RECREATIONAL_ACTIVITIES">Recreational Activities</option>
                                                                    <option value="RELIGIOUS_ORGANISATION">Religious Organisation</option>
                                                                    <option value="RETAIL">Retail</option>
                                                                    <option value="SECURITY">Security</option>
                                                                    <option value="SPORTING_RECREATIONAL_PRODUCTS">Sporting / Recreational Products</option>
                                                                    <option value="TRANSPORT">Transport</option>
                                                                    <option value="UNIVERSITY_EDUCATION">University / Education</option>
                                                                    <option value="UTILITIES">Utilities</option>
                                                                    <option value="WASTE_MANAGEMENT">Waste Management</option>
                                                                    <option value="WINE_LIQUOR">Wine / Liquor</option>
                                                                    <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                                                    <option value="OTHER">Other</option>
                                                                </select>
                                                            </div>
                                                            {errors.profile?.lineOfBusiness && (
                                                                <span className="error_message">{errors.profile.lineOfBusiness}</span>
                                                            )}
                                                        </div>
                                                    </div>


                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_relationship_to_customer">
                                                            <label>Relationship to Customer*</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control no-icon"
                                                                    name="profile.relationshipToCustomer"
                                                                    value={formData.profile.relationshipToCustomer}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Relationship</option>
                                                                    <option value="SPOUSE">Spouse</option>
                                                                    <option value="EX_SPOUSE">Ex-Spouse</option>
                                                                    <option value="CHILDREN">Children</option>
                                                                    <option value="PARENT">Parent</option>
                                                                    <option value="SIBLING">Sibling</option>
                                                                    <option value="RELATIVE">Relative</option>
                                                                    <option value="SELF">Self</option>
                                                                    <option value="FRIEND">Friend</option>
                                                                    <option value="BUSINESS_PARTNER">Business Partner</option>
                                                                    <option value="CUSTOMER">Customer</option>
                                                                    <option value="EMPLOYEE">Employee</option>
                                                                    <option value="BRANCH_OFFICE">Branch Office</option>
                                                                    <option value="SUBSIDIARY_COMPANY">Subsidiary Company</option>
                                                                    <option value="HOLDING_COMPANY">Holding Company</option>
                                                                    <option value="SUPPLIER">Supplier</option>
                                                                    <option value="CREDITOR">Creditor</option>
                                                                    <option value="DEBTOR">Debtor</option>
                                                                    <option value="FRANCHISEE">Franchisee</option>
                                                                </select>
                                                            </div>
                                                            {errors.profile?.relationshipToCustomer && (
                                                                <span className="error_message">{errors.profile.relationshipToCustomer}</span>
                                                            )}
                                                        </div>
                                                    </div>



                                                    {/* Account Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_accountNumber">
                                                            <label>Account Number</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.accountNumber"
                                                                    value={formData.accountInformation.accountNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.accountNumber && (
                                                                <span className="error_meesage">{errors.accountInformation.accountNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Account Type */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_accountType">
                                                            <label>Account Type</label>
                                                            <div className="form-controls">
                                                                <select
                                                                    className="form-control"
                                                                    name="accountInformation.type"
                                                                    value={formData.accountInformation.type}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="CHECKING">Checking</option>
                                                                    <option value="SAVING">Saving</option>
                                                                </select>
                                                            </div>
                                                            {errors?.accountInformation?.type && (
                                                                <span className="error_meesage">{errors.accountInformation.type}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Routing Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_routingNumber">
                                                            <label>Routing Number</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.routingNumber"
                                                                    value={formData.accountInformation.routingNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.routingNumber && (
                                                                <span className="error_meesage">{errors.accountInformation.routingNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* SWIFT / BIC Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_swiftBic">
                                                            <label>SWIFT / BIC Code</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.swiftBic"
                                                                    value={formData.accountInformation.swiftBic}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.swiftBic && (
                                                                <span className="error_meesage">{errors.accountInformation.swiftBic}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Name */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionName">
                                                            <label>Institution Name</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionName"
                                                                    value={formData.accountInformation.institutionName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionName && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionName}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Institution Address - Unit Number */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_unitNumber">
                                                            <label>Institution Address - Unit Number</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.unitNumber"
                                                                    value={formData.accountInformation.institutionAddress.unitNumber}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.unitNumber && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.unitNumber}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - Address Line 1 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_addressLine1">
                                                            <label>Institution Address - Address Line 1</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.addressLine1"
                                                                    value={formData.accountInformation.institutionAddress.addressLine1}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.addressLine1 && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.addressLine1}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - Address Line 2 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_addressLine2">
                                                            <label>Institution Address - Address Line 2</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.addressLine2"
                                                                    value={formData.accountInformation.institutionAddress.addressLine2}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.addressLine2 && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.addressLine2}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - Address Line 3 */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_addressLine3">
                                                            <label>Institution Address - Address Line 3</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.addressLine3"
                                                                    value={formData.accountInformation.institutionAddress.addressLine3}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.addressLine3 && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.addressLine3}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - City */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_city">
                                                            <label>Institution Address - City</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.city"
                                                                    value={formData.accountInformation.institutionAddress.city}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.city && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.city}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - State */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_state">
                                                            <label>Institution Address - State</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.state"
                                                                    value={formData.accountInformation.institutionAddress.state}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.state && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.state}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - Postal Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_postalCode">
                                                            <label>Institution Address - Postal Code</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.postalCode"
                                                                    value={formData.accountInformation.institutionAddress.postalCode}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.postalCode && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.postalCode}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Institution Address - Country Code */}
                                                    <div className="col-md-6">
                                                        <div className="form-group" id="id_institutionAddress_countryCode">
                                                            <label>Institution Address - Country Code</label>
                                                            <div className="form-controls">
                                                                <Input
                                                                    type="text"
                                                                    className="form-control no-icon"
                                                                    name="accountInformation.institutionAddress.countryCode"
                                                                    value={formData.accountInformation.institutionAddress.countryCode}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {errors?.accountInformation?.institutionAddress?.countryCode && (
                                                                <span className="error_meesage">{errors.accountInformation.institutionAddress.countryCode}</span>
                                                            )}
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12">
                                                        <div className="form-group submit-field d-flex justify-content-end mt-20 mb-0">
                                                            <a
                                                                className="btn btn-outline mr-19"
                                                                data-bs-dismiss="modal"
                                                                onClick={props.onHide}
                                                            >
                                                                Cancel
                                                            </a>
                                                            <a className="btn btn-large" onClick={IssueCardHolderHandler}>
                                                                Create Account
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <CheckButton
                                                    style={{ display: "none" }}
                                                    ref={checkBtn}
                                                />
                                            </Form>
                                        </div>
                                    </div>
                                    <div
                                        className={cardContentClassName}
                                        id="cardDetails"
                                        role="tabpanel"
                                        aria-labelledby="cardDetails-tab"
                                    >
                                        <div className="row row-card-details-popup">
                                            <div className="col-md-12">
                                                <ul className="ul-card-details-popup ul-issue-card">
                                                    <li className="mb-20">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <label>Company Name</label>
                                                            </div>
                                                            <div className="col-8">
                                                                <span>{FirstName}</span>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    <li className="mb-20">
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <label>Available Balance</label>
                                                            </div>
                                                            <div className="col-8">
                                                                <span>$ 0</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group submit-field d-flex justify-content-end mt-20 mb-0">
                                                    <button
                                                        className="btn btn-large"
                                                        data-bs-dismiss="modal"
                                                        onClick={IssueCardDoneHandler}
                                                    >
                                                        Done
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialoguePopup
                show={modalShow}
                onHide={() => setModalShow(false)}
                modelheading={modelhdng}
                modelbody={modelbdy}
                modelicon={MdlIcon}
                hideallpopups={props.onHide}
            />
        </Fragment>
    );
};
export default AddExtrnalTransferBody;
